class VeeraCampaign {
  constructor(root) {
    this.root = root;
    this.slides = [...root.querySelectorAll('[data-campaign-slide]')];
    this.dots = [...root.querySelectorAll('[data-campaign-dot]')];
    this.index = 0;
    this.timer = null;

    root.querySelector('[data-campaign-prev]')?.addEventListener('click', () => this.show(this.index - 1));
    root.querySelector('[data-campaign-next]')?.addEventListener('click', () => this.show(this.index + 1));
    this.dots.forEach((dot, index) => dot.addEventListener('click', () => this.show(index)));
    root.addEventListener('mouseenter', () => this.stop());
    root.addEventListener('mouseleave', () => this.start());
    root.addEventListener('focusin', () => this.stop());
    root.addEventListener('focusout', () => this.start());

    this.start();
  }

  show(nextIndex) {
    this.index = (nextIndex + this.slides.length) % this.slides.length;
    this.slides.forEach((slide, index) => {
      const active = index === this.index;
      slide.classList.toggle('is-active', active);
      slide.setAttribute('aria-hidden', String(!active));
      slide.querySelector('a')?.setAttribute('tabindex', active ? '0' : '-1');
    });
    this.dots.forEach((dot, index) => {
      dot.classList.toggle('is-active', index === this.index);
      dot.setAttribute('aria-current', index === this.index ? 'true' : 'false');
    });
    this.start();
  }

  start() {
    this.stop();
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    this.timer = window.setInterval(() => this.show(this.index + 1), 6500);
  }

  stop() {
    if (this.timer) window.clearInterval(this.timer);
    this.timer = null;
  }
}

document.querySelectorAll('[data-veera-home] .veera-campaign').forEach((campaign) => new VeeraCampaign(campaign));

document.querySelectorAll('[data-product-rail]').forEach((rail) => {
  const track = rail.querySelector('.veera-product-rail__track');
  const previous = rail.querySelector('[data-rail-prev]');
  const next = rail.querySelector('[data-rail-next]');
  if (!track || !previous || !next) return;

  const update = () => {
    const remaining = track.scrollWidth - track.clientWidth;
    previous.disabled = track.scrollLeft < 2;
    next.disabled = track.scrollLeft >= remaining - 2;
    rail.classList.toggle('is-static', remaining < 2);
  };

  const move = (direction) => {
    const card = track.querySelector('.veera-product-card');
    if (!card) return;
    const step = card.getBoundingClientRect().width + parseFloat(getComputedStyle(track).columnGap || 0);
    track.scrollBy({ left: direction * step * (window.innerWidth < 640 ? 2 : 3), behavior: 'smooth' });
  };

  previous.addEventListener('click', () => move(-1));
  next.addEventListener('click', () => move(1));
  track.addEventListener('scroll', update, { passive: true });
  window.addEventListener('resize', update);
  update();
});
